import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CtaBanner from '../components/CtaBanner';

const VALUES = [
  { icon: 'i-bulb', title: 'Innovation', body: "From native apps to AI hardware, we build the things we imagine ourselves." },
  { icon: 'i-shield', title: 'Integrity', body: "Honest timelines and honest trade-offs, even when that's the harder conversation." },
  { icon: 'i-users', title: 'Collaboration', body: 'We work directly with you — not through a ticket queue.' },
  { icon: 'i-star', title: 'Excellence', body: 'Native-only, self-built systems held to a standard that scales past day one.' },
];

const TEAM_PLACEHOLDERS = ['[Team Member]', '[Team Member]', '[Team Member]', '[Team Member]'];

export default function AboutUs() {
  return (
    <div className="kh">
      <Header active="about" />

      <section className="kh-page-banner">
        <div className="kh-glow" style={{ width: 420, height: 420, top: -180, left: -100 }} />
        <div className="kh-glow kh-glow-b" style={{ width: 360, height: 360, top: -140, right: -120 }} />
        <div className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px', position: 'relative', textAlign: 'center' }}>
          <div className="kh-fade-1 kh-breadcrumb">
            <a href="/">Home</a><span>/</span><span style={{ color: 'var(--text)' }}>About Us</span>
          </div>
          <h1 className="kh-fade-2 kh-page-title">About KLIK Innovatech</h1>
          <p className="kh-fade-3 kh-page-sub" style={{ maxWidth: 600 }}>A Sri Lanka&#8209;based technology company building native mobile apps and AI-powered safety hardware &mdash; end to end, in-house.</p>
        </div>
      </section>

      <section className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '90px 24px' }}>
        <div className="kh-story-grid">
          <div className="kh-story-visual">
            <div className="kh-glow" style={{ width: 260, height: 260, top: -50, left: -50 }} />
            <div className="kh-glow kh-glow-b" style={{ width: 220, height: 220, bottom: -50, right: -40 }} />
            <div style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18 }}>
              <div className="kh-icon-badge" style={{ width: 120, height: 120, borderRadius: 28 }}>
                <svg width="54" height="54"><use href="#i-shield" /></svg>
              </div>
              <p className="kh-caption">Since 2025</p>
            </div>
          </div>
          <div>
            <div className="kh-eyebrow"><span className="kh-dot" />OUR STORY</div>
            <h2 className="kh-h2" style={{ marginTop: 18 }}>Built to ship real products, not just prototypes</h2>
            <p className="kh-story-p">
              KLIK Innovatech started with a simple rule: build native, or don't build it. Every Android and iOS app we ship &mdash; including live products for TouchLK, Paddy Calculator, DTHLK, TouchLK Plus and Klik Shield &mdash; is developed natively for the best possible performance, with no cross-platform shortcuts.
            </p>
            <p className="kh-story-p" style={{ marginTop: 16 }}>
              That same in-house discipline carried us into hardware: our AI vehicle safety dash cams (ADAS, DMS, live monitoring and tracking), GPS tracking solutions and AI solar CCTV cameras are all designed and controlled by our own team, end to end. Next, we're bringing that same approach to a full smart home system &mdash; your home, in your mobile.
            </p>
          </div>
        </div>
      </section>

      <section className="kh-alt-section">
        <div className="kh-container kh-mv-grid" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-target" /></svg></div>
            <h3 className="kh-card-title" style={{ fontSize: 19, marginTop: 20 }}>Our Mission</h3>
            <p className="kh-card-body" style={{ fontSize: 14.5 }}>To build reliable native apps and AI-powered safety hardware that we design, build and stand behind ourselves &mdash; end to end.</p>
          </div>
          <div className="kh-card">
            <div className="kh-icon-badge"><svg width="24" height="24"><use href="#i-eye" /></svg></div>
            <h3 className="kh-card-title" style={{ fontSize: 19, marginTop: 20 }}>Our Vision</h3>
            <p className="kh-card-body" style={{ fontSize: 14.5 }}>To be the technology partner people trust to protect what matters &mdash; their vehicles, their property and, next, their homes.</p>
          </div>
        </div>
      </section>

      <section className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '90px 24px' }}>
        <div style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto 48px' }}>
          <div className="kh-eyebrow"><span className="kh-dot" />WHAT WE STAND FOR</div>
          <h2 className="kh-h2" style={{ marginTop: 18 }}>Our core values</h2>
        </div>
        <div className="kh-values-grid">
          {VALUES.map((v) => (
            <div className="kh-card" style={{ textAlign: 'center' }} key={v.title}>
              <div className="kh-icon-badge" style={{ margin: '0 auto' }}><svg width="22" height="22"><use href={`#${v.icon}`} /></svg></div>
              <h3 className="kh-card-title" style={{ fontSize: 16, marginTop: 18 }}>{v.title}</h3>
              <p className="kh-card-body" style={{ fontSize: 13.5 }}>{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="kh-alt-section">
        <div className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
          <div style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto 48px' }}>
            <div className="kh-eyebrow"><span className="kh-dot" />OUR TEAM</div>
            <h2 className="kh-h2" style={{ marginTop: 18 }}>The people behind KLIK</h2>
            <p className="kh-lede">Placeholder profiles &mdash; swap in your real team photos and bios.</p>
          </div>
          <div className="kh-team-grid">
            {TEAM_PLACEHOLDERS.map((name, i) => (
              <div key={i}>
                <div className="kh-team-avatar"><svg width="40" height="40"><use href="#i-user" /></svg></div>
                <h3 className="kh-card-title" style={{ fontSize: 15, marginTop: 14 }}>{name}</h3>
                <p className="kh-team-role">[Role Title]</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '90px 24px 0' }}>
        <div style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto 40px' }}>
          <div className="kh-eyebrow"><span className="kh-dot" />GET IN TOUCH</div>
          <h2 className="kh-h2" style={{ marginTop: 18 }}>Visit or reach us</h2>
        </div>
        <div className="kh-contact-grid" style={{ maxWidth: 900, margin: '0 auto' }}>
          <div className="kh-card kh-contact-row">
            <div className="kh-contact-icon"><svg width="18" height="18"><use href="#i-gps" /></svg></div>
            <p style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--text)', fontWeight: 500 }}>Kovil Kudiyiruppu, 37 St Mary's Rd, Mullaitivu 42000, Sri Lanka</p>
          </div>
          <div className="kh-card kh-contact-row">
            <div className="kh-contact-icon"><svg width="18" height="18"><use href="#i-phone" /></svg></div>
            <a href="tel:0717123790" style={{ fontSize: 14.5, color: 'var(--text)', fontWeight: 700 }}>071 712 3790</a>
          </div>
          <div className="kh-card kh-contact-row">
            <div className="kh-contact-icon"><svg width="18" height="18"><use href="#i-mail" /></svg></div>
            <a href="mailto:info@klikitech.com" style={{ fontSize: 14.5, color: 'var(--text)', fontWeight: 700 }}>info@klikitech.com</a>
          </div>
        </div>
      </section>

      <CtaBanner />
      <Footer />
    </div>
  );
}
